module.exports = __webpack_public_path__ + "static/media/nike.636598f9.png";